import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@mui/material';
import { IconButton, TextField } from '@totalsoft/rocket-ui';
import { get, set } from '@totalsoft/change-tracking-react';
import { emptyString } from 'utils/constants';
import { valueOrDefault } from 'utils/functions';
import FlexBox from 'components/common/FlexBox';

const AssetHierarchyTypeComponent = ({ hierarchy, editing, pending, handleEditMode, handleSave, handleCancel }) => {
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell>{hierarchy.name |> get}</TableCell>
      <TableCell>
        <TextField
          fullWidth
          value={hierarchy.imageUrl |> get |> valueOrDefault(emptyString)}
          onChange={hierarchy.imageUrl |> set}
          disabled={pending || !editing}
        />
      </TableCell>
      <TableCell align='right'>
        {!editing ? (
          <IconButton
            type='edit'
            size='tiny'
            variant='text'
            color='primary'
            tooltip={t('AssetHierarchy.Type.Edit')}
            onClick={handleEditMode}
            disabled={pending}
          />
        ) : (
          <FlexBox gap={0.5} justifyContent='end'>
            <IconButton
              type='cancel'
              size='tiny'
              variant='text'
              color='primary'
              tooltip={t('AssetHierarchy.Type.Cancel')}
              onClick={handleCancel}
              disabled={pending}
            />
            <IconButton
              type='save'
              size='tiny'
              variant='text'
              color='primary'
              tooltip={t('AssetHierarchy.Type.Save')}
              onClick={handleSave}
              disabled={pending}
            />
          </FlexBox>
        )}
      </TableCell>
    </TableRow>
  );
};
AssetHierarchyTypeComponent.propTypes = {
  hierarchy: PropTypes.object.isRequired,
  editing: PropTypes.bool.isRequired,
  pending: PropTypes.bool.isRequired,
  handleEditMode: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired
};

export default AssetHierarchyTypeComponent;
